import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { EASE } from "../components/Reveal";
import salon406 from "../assets/salon406.jpg";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="bg-ivory">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 py-16 sm:px-8 lg:grid-cols-2 lg:py-24">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: EASE }}
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark">
            Nichole Olsen, NP &middot; Salon 406, North Ogden
          </p>
          <h1 className="mt-5 font-serif text-5xl font-medium leading-[1.05] tracking-tight text-forest sm:text-6xl lg:text-7xl">
            Confidence, delivered naturally.
          </h1>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-moss sm:text-lg">
            Injectables, hormone therapy, weight loss, wellness care and Utah
            Medical Cannabis Cards — with a nurse practitioner who takes her time.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3">
            <Link
              to="/book"
              data-testid="hero-book-button"
              className="rounded-md bg-forest px-7 py-3.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:bg-forest-dark"
            >
              Book a Consultation
            </Link>
            <a
              href="#cannabis"
              data-testid="hero-cannabis-link"
              className="rounded-md border border-linen px-7 py-3.5 text-sm font-semibold text-forest transition-colors duration-300 hover:border-forest"
            >
              Utah Cannabis Cards
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-2 border-t border-linen pt-6 text-sm text-moss">
            <span>Complimentary consultations</span>
            <span>$60 phone visits</span>
            <span>Cannabis cards from $75</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
          className="overflow-hidden rounded-lg"
        >
          <img
            src={salon406}
            alt="Salon 406 in North Ogden, Utah — home of Releaf Wellness & Aesthetics"
            className="h-[420px] w-full object-cover object-[center_40%] lg:h-[560px]"
          />
        </motion.div>
      </div>
    </section>
  );
}
